import styled from "styled-components";

function ElementalFilter() {
    return(ElementalList)
}


const ElementalList = [
    ["propriedade", ""],
    ["todas", ""],
    ["Neutro", "Neutro"],
    ["Fogo", "Fogo"],
    ["Agua", "Água"],
    ["Vento", "Vento"],
    ["Terra", "Terra"],
    ["Sagrado", "Sagrado"],
    ["Maldito", "Maldito"],
    ["Sombrio", "Sombrio"],
    ["Fantasma", "Fantasma"]
]

export default ElementalFilter;